export const grid = {
  default: {
    gap: 24,
  },
  desktopLarge: {
    gap: 32,
  },
}
